import { render } from "./PublicNewsView.vue?vue&type=template&id=16ecf8ac&scoped=true"
import script from "./PublicNewsView.vue?vue&type=script&lang=js"
export * from "./PublicNewsView.vue?vue&type=script&lang=js"

import "./PublicNewsView.vue?vue&type=style&index=0&id=16ecf8ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ecf8ac"]])

export default __exports__